import React from "react";
import "../../assets/css/lotto12v2.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
    addLotto12v2Betting,
    clearAllInv, clearCartLotto12v2, deleteLotto12v2Betting,
    fetchLotto12v2DrawingResult, fetchLotto12v2ListBetting,
    fetchLotto12v2RecentBetReport,
    fetchLotto12v2RecentDraw,
    fetchStatistic12v2, lotto12v2ConfirmBettingNow
} from "../../store/lotto12v2/action";
import { clientAp, lotto12DrawStyle } from "../../constants/general";
import { SUBSCRIPTION_LOTTO12V2 } from "../../constants/lotto12";
import { fetchUserBalance, fetchUserBalanceValidate, setIsAddToCart, setIsAutoPrint } from "../../store/user/action";
import PropTypes from "prop-types";
import { Lotto12v2Context } from "../../store/lotto12v2/Lotto12v2Context";
import moment from "moment";
import swal from "sweetalert";
import { sessionStore } from "../../utils/storage";



class MainDrawingWrapper extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showDeleteBetting: false,
            showBetting: false,
            betCode: "",
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betGameRange: "",
            betGameTime: "",
            betMessage: "",
            isShowValidateBalance: false,
            messageValidateBalance: null,
            isEnableBetNow: true,
            status: undefined,
        };
    }

    componentDidMount() {
        this.subscription();
        this.refreshData();
    }

    refreshData = () => {
        const {
            fetchStatistic12v2,
            fetchLotto12v2RecentDraw,
            fetchLotto12v2RecentBetReport,
            fetchUserBalance
        } = this.props;

        this.getDrawing();
        fetchStatistic12v2();
        fetchLotto12v2RecentDraw();
        fetchUserBalance();
        fetchLotto12v2RecentBetReport();
    }

    getDrawing = () => {
        const {
            fetchLotto12v2DrawingResult,
            drawStyle
        } = this.props;
        return fetchLotto12v2DrawingResult(drawStyle === lotto12DrawStyle.circle);
    }

    onDrawStatusChange = (currentDraw) => {
        const { status } = this.state;
        if (currentDraw.status !== status) {
            if (status && currentDraw.status === "OPEN") {
                this.refreshData();
            }
            if (status && currentDraw.status === "RELEASE") {
                this.getDrawing();
            }
            this.verifyCurrentDraw(currentDraw);
        }
        this.setState({ status: currentDraw.status });
    }

    verifyCurrentDraw = currentDrawCode => {
        let betList = sessionStore.get("betting_lotto12v2", []);
        if (betList.length) {
            let firstItem = betList[0];
            if (firstItem.drawCode !== currentDrawCode) {
                this.props.clearCartLotto12v2();
            }
        }

    }

    subscription = () => {
        this.sub = clientAp.subscribe({
            query: SUBSCRIPTION_LOTTO12V2,
        }).subscribe({
            next: (event) => {
                if (event.data && event.data.v_yuki_drawing) {
                    let currentDraw = event.data.v_yuki_drawing[0] || {};
                    this.onDrawStatusChange(currentDraw);
                }
            },
            error: (err) => {
                console.error("err", err);
            }
        });
    }

    componentWillUnmount() {
        this.sub && this.sub.unsubscribe();
        clearAllInv();
    }

    onCancelBetting = () => {
        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: '',
            betGameOdds: '',
            pendingLotto12: this.props.user.userBalance.pendingLotto12,
            betMessage: "",
            betGameRange: "",
            betGameTime: ""
        })
    }

    componentDidUpdate() {
        if (this.props.isStopBet && this.state.showBetting) {
            this.onCancelBetting()
        }
    }


    onBetting = (item) => {
        if (!this.props.isStopBet) {
            this.props.fetchUserBalanceValidate()
                .then(() => {
                    this.setState({
                        showBetting: true,
                        betGameType: item.name,
                        betGameOdds: item.value,
                        betGameRange: item.resultRange,
                        betCode: item.code,
                        betGameTime: moment(new Date()).format('HH:mm:ss')
                    });
                }).catch(error => {
                    const { t } = this.props;
                    this.setState({
                        isShowValidateBalance: true,
                        messageValidateBalance: t("labels:common." + error.response.data.message)
                    });
                })
        }
    }

    clickAmountBetBtn = (amount) => {
        let betAmount = this.state.betAmount || 0

        this.setState({
            betAmount: parseInt(betAmount) + amount
        })
    }

    resetDefaultAmount = () => {
        this.setState({ betAmount: 0 })
    }

    changeBetAmount = (e) => {
        if (e.target.value >= 0 || !isNaN(e.target.value) || e.target.value === undefined) {
            this.setState({ betAmount: e.target.value })
        }
    }

    setBetMessage = (message = "") => {
        this.setState({ betMessage: message })
    }

    getTotalCartAmount = () => {
        return this.props.fetchLotto12v2ListBetting({ isClear: false }) || 0;
    }


    onConfirmBetting = async (logs) => {
        const { user: { isAddToCart, isAutoPrint } } = this.props
        const {
            betCode,
            betAmount,
            betGameOdds
        } = this.state;
        const data = {
            drawCode: this.props.newResult.drawCode,
            betTypeCode: betCode,
            amount: betAmount,
            betLog: logs,
            rebateRate: betGameOdds
        }

        await this.props.addLotto12v2Betting(data);
        !isAddToCart && this.submitBetNow(isAutoPrint);

        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betCode: "",
            betGameRange: "",
            betGameTime: "",
            betMessage: ""
        })
    }

    showConfirmDelete = (id) => {
        this.props.deleteLotto12v2Betting({ id: id })
    }

    submitBetNow = (isPrint) => {
        const { isEnableBetNow } = this.state;
        isEnableBetNow && this.props.lotto12v2ConfirmBettingNow(() => this.setState({ isEnableBetNow: false }))
            .then(() => {
                this.props.fetchLotto12v2RecentBetReport().then(() => isPrint && document.getElementById("print-button").click());
                this.props.fetchUserBalance();
                this.setState({ isEnableBetNow: true })
            }).catch((error) => {
                this.setState({ isEnableBetNow: true })
                const { response } = error;
                response && swal(response.data.message, { icon: "error", button: "បិទ" });
            })
    }

    afterPrint = () => {
        this.props.fetchLotto12v2DrawingResult(this.props.drawStyle === lotto12DrawStyle.circle);
    }

    tensecondCallback = (sec) => {
        if (sec <= 9) {
            this.onCancelBetting();
        }
    }


    render() {
        const contextValue = {
            ...this.props,
            ...this.state,
            onCancelBetting: this.onCancelBetting,
            onBetting: this.onBetting,
            clickAmountBetBtn: this.clickAmountBetBtn,
            resetDefaultAmount: this.resetDefaultAmount,
            changeBetAmount: this.changeBetAmount,
            isValidBetAmount: this.isValidBetAmount,
            setBetMessage: this.setBetMessage,
            tensecondCallback: this.tensecondCallback,
            getTotalCartAmount: this.getTotalCartAmount,
            onConfirmBetting: this.onConfirmBetting,
            showConfirmDelete: this.showConfirmDelete,
            submitBetNow: this.submitBetNow,
            afterPrint: this.afterPrint
        }

        return <Lotto12v2Context.Provider value={contextValue}>
            {this.props.children}
        </Lotto12v2Context.Provider>
    }
}

const mapStateToProps = state => ({
    user: state.user,
    betting: state.lotto12v2.betting,
    config: state.config,
    ...state.lotto12v2.drawing
})

MainDrawingWrapper.propTypes = {
    drawStyle: PropTypes.string
}

export default withTranslation()(connect(
    mapStateToProps,
    {
        fetchLotto12v2DrawingResult,
        fetchStatistic12v2,
        fetchLotto12v2RecentDraw,
        fetchUserBalance,
        fetchLotto12v2RecentBetReport,
        clearAllInv,
        clearCartLotto12v2,
        fetchUserBalanceValidate,
        fetchLotto12v2ListBetting,
        addLotto12v2Betting,
        lotto12v2ConfirmBettingNow,
        setIsAutoPrint,
        setIsAddToCart,
        deleteLotto12v2Betting
    }
)(MainDrawingWrapper));
